import React from 'react'

export default () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#D97490" fillRule="evenodd">
      <path d="M16.048 2.217l-11.19 11.19-1.6-1.598L14.45.617z" />
      <path d="M6.456 11.81l-1.598 1.598L.06 8.61l1.6-1.598z" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/checkboxIcon.js